export default "/assets/images/mila-feed-16.mp4?29652541adffc90875eeeaada7381d23";